<template>
	<v-toolbar-items>
		<v-flex shrink align-self-center class="caption">
			{{ $tc('GENERAL_TOOLBAR_PAGINATION_TEXT', count, {
				min: pageRangeMin + 1,
				max: pageRangeMax,
				total,
			}) }}
		</v-flex>
		<v-tooltip bottom>
			<template #activator="data">
				<v-btn small icon :disabled="isFirst" v-on="data.on" @click="prev">
					<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-chevron-left</v-icon>
				</v-btn>
			</template>
			<span>{{ $t('GENERAL_TOOLBAR_PAGINATION_PREV_HINT') }}</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template #activator="data">
				<v-btn small icon :disabled="isLast" v-on="data.on" @click="next">
					<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-chevron-right</v-icon>
				</v-btn>
			</template>
			<span>{{ $t('GENERAL_TOOLBAR_PAGINATION_NEXT_HINT') }}</span>
		</v-tooltip>
	</v-toolbar-items>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'bar-pagination',
	props: {
		page: Number,
		count: { type: Number, default: 1 },
		total: Number,
	},
	computed: {
		...mapState(['toolbarIconColor', 'toolbarIconSize']),
		pageRangeMin() {
			return this.page * this.count;
		},
		pageRangeMax() {
			return Math.min(this.pageRangeMin + this.count, this.total);
		},
		isFirst() {
			return this.page <= 0;
		},
		isLast() {
			return this.pageRangeMax >= this.total;
		},
	},
	methods: {
		prev() {
			if (this.isFirst) { return }
			const page = this.page - 1;
			const index = page * this.count;

			this.$emit('previous', {
				page,
				index,
				range: {
					min: index,
					max: index + this.count,
				},
			});
		},
		next() {
			if (this.isLast) { return }
			const page = this.page + 1;
			const index = page * this.count;
			
			this.$emit('next', {
				page,
				index,
				range: {
					min: index,
					max: index + this.count,
				},
			});
		},
	},
}
</script>
